module.exports = __webpack_public_path__ + "img/base.a7c5bf48.png";